// How the panel READS Alto's answers (backend: investment/modules/alto-offering). Shared by the detail's
// Operations card and the Add Property wizard, which registers right after creating when asked to.

// `adminRegisterAltoOffering.outcome`, in the operator's words.
const OUTCOME_COPY = {
  CREATED: 'Offering created in Alto',
  ALREADY_REGISTERED: 'Already registered in Alto',
  SKIPPED_INCOMPLETE: 'Skipped: the note is missing data Alto needs',
  FAILED: 'Alto registration failed',
};

export function registrationMessage(result) {
  const head = OUTCOME_COPY[result.outcome] || result.outcome;
  const listing = result.noteListing ? ` under listing ${result.noteListing}` : '';
  const detail = result.detail ? ` (${result.detail})` : '';
  return `${head}${listing}${detail}`;
}

// The backend's copy, verbatim: its ALTO_OFFERING_* errors already name what is missing or wrong.
export const backendMessage = (error) => error.message.replace(/^GraphQL error: /, '');

// The two truths side by side (`registered` is OUR flag, `existsInAlto` is Alto right now) folded into
// the one state the operator acts on. `action`: whether "Register in Alto" has anything left to do.
export function altoOfferingState(status) {
  if (!status.noteListing) {
    return {
      color: 'default',
      label: 'No listing yet',
      note: 'The note has no listing code, so there is nothing to register.',
      action: false,
    };
  }
  const missing = status.missingDocuments || [];
  if (status.existsInAlto && missing.length > 0) {
    return {
      color: 'orange',
      label: `Missing documents: ${missing.join(', ')}`,
      note: 'Alto still waits for paperwork — investors are told they have no access to this deal. Register uploads what is missing.',
      action: true,
    };
  }
  if (status.existsInAlto && !status.registered) {
    return {
      color: 'gold',
      label: 'Exists in Alto but not confirmed',
      note: 'Alto holds the offering but our base does not say so yet. Register verifies it and marks the note.',
      action: true,
    };
  }
  if (status.existsInAlto) {
    return { color: 'green', label: 'Registered', action: false };
  }
  if (status.registered) {
    return {
      color: 'red',
      label: 'Marked registered, but Alto has no offering',
      note: 'Our base says registered and Alto says no (rotated credentials, a hand-set flag). Investors buying through Alto get an error until it is registered again.',
      action: true,
    };
  }
  return {
    color: 'default',
    label: 'Not registered',
    note: 'Investors cannot buy this note through Alto until its offering exists.',
    action: true,
  };
}
